import $httpReq from '@/utils/httpRequest';
let stateData = {
    checkResultAttConfig:[],//自然人基本信息附件配置，[check_result_att]
    noticeAttConfig:[],//公告
    entPrizeAtt:[],
}

const getDataByType = function(categoryCode,callback){
    $httpReq.get(`/attachment/getAttDatas?categoryCode=${categoryCode}`).then((res) => {
        if (res.data.code == 1 && res.data.data.length > 0) {
            res.data.data.forEach((item,index)=>{
                var remark = item.remark?JSON.parse(item.remark):{};
                item.required = remark.required || false;
                item.allows= remark.allows || '*';
                item.templateSrc= remark.templateSrc || '';
                item.describeInfo= remark.describeInfo || '';
                item.fileTypeName = item.name;
                item.filePath = "";
                item.name = "";
                // delete item.id;
            })
            if(callback)callback(res.data.data)
        }
    })
}

export default {
    namespaced: true,
    state:stateData,
    mutations:{
        setNoticeAttConfig(state,data){
            state.noticeAttConfig = data;
        },
        setCheckResultAttConfig(state,data){
            state.checkResultAttConfig = data;
        },
        setEntPrizeAtt(state,data){
            state.entPrizeAtt = data;
        },
    },
    actions:{
        getCheckResultAttConfig({commit}){
            if(stateData.checkResultAttConfig.length == 0){
                getDataByType('check_result_att',function(data){
                    commit('setCheckResultAttConfig',data)
                })
            }else{
                commit('setCheckResultAttConfig',stateData.checkResultAttConfig)
            }

        },
        getNoticeAttConfig({commit}){
            if(stateData.noticeAttConfig.length == 0){
                getDataByType('check_result_notice_att',function(data){
                    commit('setNoticeAttConfig',data)
                })
            }else{
                commit('setNoticeAttConfig',stateData.noticeAttConfig)
            }
        },
    }
}